import React from "react";
import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";
import { withLocalizeStrings } from "../../../languages/Localize";

const StyledContainer = styled(Box)`
    background: ${({ theme }) => theme.colors.transparent};
    height: 50%;
    margin-top: 20%;
`;
const StyledHeaderLabel = styled(Flex)`
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: ${({ theme }) => theme.space[3]}px;
`;

const PanelImpressionDone = ({ strings }) => {
    return (
        <StyledContainer sx={{ mx: [3, 4] }}>
            <StyledHeaderLabel fontWeight="bold" fontSize={[4, 5]} padding={3}>
                {strings.register.common.IMPRESSION_DONE}
            </StyledHeaderLabel>
        </StyledContainer>
    );
};

export default withLocalizeStrings(PanelImpressionDone);
